import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmployeeFeedbackComponent } from './employee-feedback.component';
import { VerificationStatusModule } from "../../components/verification-status/verification-status.module";



@NgModule({
  declarations: [EmployeeFeedbackComponent],
  imports: [
    CommonModule,
    VerificationStatusModule,
  ],
  exports: [
    EmployeeFeedbackComponent
  ]
})
export class EmployeeFeedbackModule { }
